export class Invite {

  id: number;
  email: string;
  expiresAt: string;
  roleId: number;
  tokenUsed: boolean;
  constructor() {
    this.id = null;
    this.email = '';
    this.expiresAt = '';
    this.roleId = null;
    this.tokenUsed = null;
  }
}
